<template>
    <div @click="open()">
        <v-text-field
            ref="input"
            :value="selectedDateDescription"
            append-icon="event"
            hide-details
            label="Plan Date"
            outline
            dense
            readonly>
        </v-text-field>
        <v-dialog
            v-if="editMode"
            :value="true"
            persistent
            @keydown.esc="cancel()"
            width="290px">
            <v-date-picker scrollable
                :value="editValue"                
                @input="updateValue">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="cancel()">Cancel</v-btn>
                <v-btn text color="primary" @click="submit()">OK</v-btn>
            </v-date-picker>
        </v-dialog>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        value: {
            type: String,
            required: true
        }
    },
    data(){
        return {
            editMode: false,
            localValue: null
        };
    },
    computed: {
        editValue(){
            if(this.localValue == null){
                return moment(this.value).format('YYYY-MM-DD');
            }

            return moment(this.localValue).format('YYYY-MM-DD');
        },
        selectedDateDescription(){
            return this.$options.filters.formatDate(this.value)
        }
    },
    methods: {
        open(){
            this.editMode = true;
        },
        updateValue(newValue){
            this.localValue = moment(newValue, "YYYY-MM-DD").format('YYYY-MM-DD');
        },
        cancel(){
            this.localValue = null;
            this.editMode = false;
        },
        submit(){
            this.$emit("input", moment(this.editValue, "YYYY-MM-DD").format('YYYY-MM-DD'));
            this.localValue = null;
            this.editMode = false;
        }
    },
    created(){
        
    }
}
</script>